import { ReactElement } from 'react';
import { IntField, TextField } from '@ff-it/form';
import { CategoryField } from '../category/MediaCategoryField';
import { AllActivityTypesField, LanguageField } from 'components';
import { useFieldValue } from 'hooks';
import { ActivityType } from 'types';
import { OutletOrServiceCategoryKind } from './types';

export function OutletOrServiceCategoryForm(): ReactElement {
  const kind = useFieldValue<OutletOrServiceCategoryKind>('kind');
  const type = useFieldValue<ActivityType | null>('type');
  return (
    <div className="container px-0 ml-0">
      <div className="form-row">
        <TextField name="name" label="Name" className="col-md-6" required />
      </div>
      <div className="form-row">
        <AllActivityTypesField name="type" label="Type" placeholder="Any type" className="col-md-3" />
        {kind === 'OUTLET' && (
          <LanguageField
            name="language"
            label="Language"
            className="col-md-3"
            help="Primary content or broadcast language"
          />
        )}
      </div>
      <div className="form-row">
        <CategoryField name="category" label="Category" className="col-md-6" help="Default category for products" />
      </div>
      {kind === 'OUTLET' && type === 'PRESS' && (
        <div className="form-row">
          <IntField
            name="press_circulation"
            label="Circulation"
            className="col-md-3"
            help="Copies per issue, as the publisher states it"
          />
          <TextField
            name="press_format"
            label="Format"
            className="col-md-3"
            help="Page format in the vendor's own words, for example A3"
          />
          <TextField
            name="press_periodicity"
            label="Periodicity"
            className="col-md-3"
            help="How often the title appears, in the vendor's own words"
          />
          <TextField name="technical_specification_url" label="Technical specification URL" className="col-md-6" />
        </div>
      )}
    </div>
  );
}
